const key = 'cabmun-surveys';
type ServeyProps = { visited: Date | null; answered: Date | null };
type Props = Record<string, ServeyProps>;

const defaultServeyProps: ServeyProps = { visited: null, answered: null };
function set(params: Props) {
  localStorage.setItem(key, JSON.stringify(params));
}

function get(): Props {
  return JSON.parse(localStorage.getItem(key) || '{}');
}

export const getSurveysData = (serveyName: string) => {
  const getted = get();

  return getted[serveyName] ? getted[serveyName] : defaultServeyProps;
};

export const setSurveysData = (serveyName: string, data: { visited?: Date; answered?: Date }) => {
  const getted = get();
  set({
    ...getted,
    [serveyName]: { ...(getted[serveyName] ? getted[serveyName] : defaultServeyProps), ...data },
  });
};
